import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName } from '@material-ui/core/styles';
import jwt_decode from 'jwt-decode';

// components
import Layout from "./Layout";
import MainLayout from './MainLayout/MainLayout';
import AdminLayout from './AdminLayout/AdminLayout';
import StudentLayout from "./StudentLayout/StudentLayout";
import TeacherLayout from "./TeacherLayout/TeacherLayout";

// pages
import Error from "../pages/error";
import Login from "../pages/login";
import AdminLogin from '../pages/mainAdmin/AdminLogin';
import checkTokenService from '../services/checkToken';
import Cookies from 'universal-cookie';

// context
import Constants from "../utils/consts";

// Functions
import { getServiceName } from "../utils/consts";
import getClient from "../services/getClient";

// Firebase
import { initializeApp } from 'firebase/app';
import UserToken from "./UserToken";
import Help from "../pages/Help";


const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: true, // won't minify CSS classnames when true
  productionPrefix: 'c', // 'jss' by default
});

var isAuthenticated;
var isAdminAuth;

export default class App extends React.Component{
  
  constructor() {
    super();
    this.state = { isLoading: true };
  }

  getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result)
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}

handleCallbackResponse(response) {

  var userObject = jwt_decode(response.credential);
  console.log(userObject);
}

  async componentDidMount() {

    let path = window.location.hostname
    if (path.includes("appiusacademy")) {
      window.location.href = window.location.href.split("appiusacademy.com").join("hdemia.cloud");
    }

    const cookies = new Cookies();
    var token = cookies.get('token', { path: '/' });
    var uname = cookies.get('username', { path: '/' });
    cookies.set('mainColor', 'F58320', { path: '/' });
    cookies.set('secondaryColor', 'FFC260', { path: '/' });
    const db = cookies.get('db', { path: '/' });

    this.client = undefined;
    if (db) {
      this.client = await getClient(uname, token, db);
      if (this.client) window.sessionStorage.setItem('logo', this.client.logoImage);
    }

    document.title = getServiceName();

    let res = await checkTokenService(uname, token);
    isAuthenticated = res;

    /* global google */
    /* google.accounts.id.initialize({
      client_id: "656471515583-qiupck5f2a3cuod1j9kdvl08gfp4jfqr.apps.googleusercontent.com", 
      callback: this.handleCallbackResponse
    }); */

    this.setState({ isLoading: false });
  }

  render() {

    if (this.state.isLoading === true){
      return <div />;
    }

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const mode = cookies.get('mode', { path: '/' });
    const userType = parseInt(window.sessionStorage.getItem('user_type'));
    
    var db = '';
    if (!window.location.href.split('/')[3].includes('main') && !window.location.href.split('/')[3].includes('admin')) {
        
        db = window.location.href.split('/')[3];

        if (db.includes('#')) {
          db = db.slice(0, -1);
        }
        cookies.set('db', db, { path: '/' });
    }

    var redirectUrl = '';

    if (window.location.href.split('/')[3].includes('admin')) {

      if (username == 'sys_admin') {
        if(mode == '') {
            isAdminAuth = false;
            redirectUrl = "/login";
        } else if (mode == 'sys-admin') {
            isAdminAuth = true;
            redirectUrl = '/admin/clients';
        }
      } else {
          isAdminAuth = false;
          redirectUrl = "/login";
      }

    } else if (!window.location.href.split('/')[3].includes('admin') && (window.location.href.split('/')[3].includes('main') || window.location.href.split('/')[3] === '')) {
      redirectUrl = '/main/home';
    } else if (window.location.href.split('/')[3].includes('usertoken')) {
      redirectUrl = '/usertoken';
    } else if (window.location.href.split('/')[3].includes('help')) {
      redirectUrl = '/help';
    } else {
      if (userType !== null && userType !== '') {
        redirectUrl = "/app/dashboard";
      } else {
        redirectUrl = "/login";
      }
     }

      return (
        <JssProvider generateClassName={ generateClassName }>
        <HashRouter>
            { Constants.apisFolder.includes('test') && (
              <div style={{ position: 'absolute', top: 0, left: 0, paddingTop: 5, height: 30, width: '100%', textAlign: 'center', backgroundColor: 'red', color: 'white', zIndex: 2000 }}>
                <p style={{ fontWeight: 'bold', fontSize: 14 }}>Ambiente di test</p>
              </div>
            )}
          <Switch>
  
            <Route exact path="/" render={() => <Redirect to={redirectUrl} />} />
            <PrivateRoute path={Constants.apisFolder} render={() => <Redirect to={redirectUrl} />} />
            <PrivateRoute path={Constants.apisFolder + 'pdf/'} render={() => <Redirect to={redirectUrl} />} />
            <PrivateRoute path="/app" component={(userType == 0 || userType == 4) ? Layout : userType == 1 ? StudentLayout : userType == 2 ? TeacherLayout : Login} />
            <PrivateRoute path="/billing" component={Layout} />
            <PrivateRoute path="/main" component={MainLayout} />
            <PublicRoute path="/usertoken" component={UserToken} />
            <PrivateRoute path="/help" component={Help} />
            <PrivateRoute path="/admin" component={AdminLayout} />
            <PublicRoute path="/login" component={window.location.href.split('/')[3].includes('admin') ? AdminLogin : Login} />
            <Route component={Error} />
          </Switch>
        </HashRouter>
        </JssProvider>
      );
      
    }
  }

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    
    let userType = window.sessionStorage.getItem('user_type');
    
    return (
      <Route
        {...rest}
        render={props =>
          ((userType != undefined && userType != null && userType != '') || isAdminAuth || window.location.href.includes('admin') || window.location.href.includes('main')) ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {

    let userType = window.sessionStorage.getItem('user_type');

    return (
      <Route
        {...rest}
        render={props =>
          ((userType != undefined && userType != null && userType != '') || isAdminAuth) ? (
            <Redirect to={{ pathname: '/' }} />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }

